module.exports = __webpack_public_path__ + "3015918add7f45c6c982575768cd79e5.png";